function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "visible", "overflow", "zIndex", "top", "left", "bottom", "right", "extend"],
  _excluded2 = ["children", "visible", "title", "onClose", "zIndex", "actions", "secondaryAction"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import PropTypes from 'prop-types';
import React, { useRef, forwardRef } from 'react';
import { useFela } from 'react-fela';
import Box from '../box/index.js';
import Grid from '../grid/index.js';
import Text from '../text/index.js';
import FloatingActionButton from '../floatingActionButton/index.js';
import { IconClose } from '../icons/index.js';
var containerStyle = function containerStyle(_ref) {
  var zIndex = _ref.zIndex,
    overflow = _ref.overflow,
    top = _ref.top,
    left = _ref.left,
    bottom = _ref.bottom,
    right = _ref.right;
  return {
    position: 'fixed',
    overflowY: overflow,
    maxHeight: '100%',
    zIndex: zIndex,
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    paddingRight: 'env(safe-area-inset-right)',
    paddingLeft: 'env(safe-area-inset-left)',
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)'
  };
};
function Overlay(_ref2) {
  var children = _ref2.children,
    _ref2$visible = _ref2.visible,
    visible = _ref2$visible === void 0 ? false : _ref2$visible,
    _ref2$overflow = _ref2.overflow,
    overflow = _ref2$overflow === void 0 ? 'auto' : _ref2$overflow,
    _ref2$zIndex = _ref2.zIndex,
    zIndex = _ref2$zIndex === void 0 ? 10 : _ref2$zIndex,
    top = _ref2.top,
    left = _ref2.left,
    bottom = _ref2.bottom,
    right = _ref2.right,
    extend = _ref2.extend,
    props = _objectWithoutProperties(_ref2, _excluded);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    extend: [extend, containerStyle({
      zIndex: zIndex,
      overflow: overflow,
      top: top,
      left: left,
      bottom: bottom,
      right: right
    })]
  }), children);
}
var titleStyle = {
  borderBottomWidth: 1,
  borderBottomColor: 'border',
  borderBottomStyle: 'solid'
};
var actionBarStyle = {
  borderTopWidth: 1,
  borderTopColor: 'border',
  borderTopStyle: 'solid'
};
var closeStyle = {
  cursor: 'pointer'
};
var Modal = /*#__PURE__*/forwardRef(function (_ref3, userRef) {
  var children = _ref3.children,
    visible = _ref3.visible,
    title = _ref3.title,
    onClose = _ref3.onClose,
    zIndex = _ref3.zIndex,
    actions = _ref3.actions,
    secondaryAction = _ref3.secondaryAction,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var innerRef = useRef();
  var _useFela = useFela(),
    theme = _useFela.theme;
  var ref = userRef || innerRef;
  return /*#__PURE__*/React.createElement(Overlay, {
    visible: visible,
    justifyContent: "center",
    alignItems: "center",
    zIndex: zIndex,
    overflow: "hidden",
    "data-test": props['data-test'],
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    bg: [title ? 'background.primary' : 'rgba(0, 0, 0, 0.3)',, 'rgba(0,0,0,0.3)'],
    onClick: function onClick(e) {
      var isClickOnInner = ref.current.contains(e.target);
      if (!isClickOnInner && onClose) {
        onClose();
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    bg: "background.primary",
    alignSelf: "center",
    height: [title ? '100%' : 'auto',, 'auto'],
    maxHeight: [title ? '100%' : 'calc(100% - 16px)',, 'calc(100% - 64px)'],
    width: [title ? '100%' : 'calc(100% - 16px)',, 'auto'],
    maxWidth: ['100%',, title ? 800 : 520],
    minWidth: 240,
    marginVertical: [title ? 0 : 4,, 16],
    marginHorizontal: title ? 0 : 4,
    extend: {
      overflow: 'hidden',
      boxShadow: title ? 0 : '0 0 30px 0 rgba(0, 0, 0, 0.1)',
      borderRadius: title ? 0 : theme.tokens.cornersLarge,
      medium: {
        boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
        borderRadius: theme.tokens.cornersLarge
      }
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: '1fr auto 1fr',
    extend: _objectSpread({
      padding: '16px',
      justifyItems: 'center',
      alignItems: 'center'
    }, title && titleStyle),
    areas: ['"secondaryHeader header closeButton"']
  }, secondaryAction && !Array.isArray(secondaryAction) && /*#__PURE__*/React.createElement(Box, {
    extend: {
      justifySelf: 'start',
      gridArea: 'secondaryHeader'
    }
  }, secondaryAction), /*#__PURE__*/React.createElement(Box, {
    extend: {
      gridArea: 'header'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "ash",
    subStyle: "emphasis",
    align: "center"
  }, title || ' ')), /*#__PURE__*/React.createElement(Box, {
    marginRight: [-2,, 0],
    extend: _objectSpread({
      justifySelf: 'end',
      gridArea: 'closeButton'
    }, closeStyle)
  }, /*#__PURE__*/React.createElement(FloatingActionButton, {
    intent: "function",
    "data-test": "close-modal",
    onClick: onClose,
    icon: IconClose,
    label: "St\xE4ng f\xF6nster"
  }))), /*#__PURE__*/React.createElement(Box, {
    "data-id": "modal-content",
    padding: [4,, 10],
    paddingTop: [title ? 4 : 0,, title ? 10 : 0],
    paddingBottom: 0,
    shrink: 1,
    grow: 1,
    extend: {
      overflow: 'auto',
      overscrollBehavior: 'contain'
    }
  }, children, /*#__PURE__*/React.createElement(Box, {
    marginBottom: [4,, 10]
  })), actions && Array.isArray(actions) && /*#__PURE__*/React.createElement(Box, {
    direction: ['column',, 'row'],
    paddingVertical: 6,
    paddingHorizontal: [6,, 10],
    width: "100%",
    space: 4,
    extend: actionBarStyle,
    justifyContent: actions.length > 1 ? 'space-between' : 'flex-end'
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      alignSelf: ['stretch',, 'flex-start']
    }, action);
  }))));
});
export default Modal;
Modal.displayName = 'Modal';
Modal.propTypes = {
  /** A list of actions rendered in the action bar. */
  actions: PropTypes.array,
  /** The content of the modal. */
  children: PropTypes.element,
  /** A listener that is called once clicked outside of the modal. */
  onClose: PropTypes.func,
  /** A secondary Action in the header of the modal. */
  secondaryAction: PropTypes.func,
  /** Sets the title of the modal. */
  title: PropTypes.string,
  /** Sets the visiblity of the modal. */
  visible: PropTypes.bool,
  /** Sets the zIndex of the modal. */
  zIndex: PropTypes.number
};